import { getLabelsProductListingCopy } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors.js';

export const getBopisLabels = (labels) => {
  return getLabelsProductListingCopy(labels);
};

export const getAccessibilityLabels = (labels) => {
  return {
    lbl_tick_icon: labels.lbl_tick_icon,
    lbl_plus_icon: labels.lbl_plus_icon,
    previousPrice: labels.lbl_previous_price,
    lbl_right_arrow: labels.lbl_right_arrow,
    rating: labels.lbl_rating,
    outOf: labels.lbl_out_of,
  };
};
